import { render, staticRenderFns } from "./MsgSever.vue?vue&type=template&id=4842b6c6&scoped=true"
import script from "./MsgSever.vue?vue&type=script&lang=js"
export * from "./MsgSever.vue?vue&type=script&lang=js"
import style0 from "./MsgSever.vue?vue&type=style&index=0&id=4842b6c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4842b6c6",
  null
  
)

export default component.exports